import { merge } from 'lodash/object';

import filesRule from './rules/files';
import scssRule from './rules/scss';

import scssPlugin from './plugins/scss';
import manifestPlugin from './plugins/manifest';
import processEnvPlugin from './plugins/processEnv';

import generateConfig, { cwd } from './generateConfig';

export const EXTENSIONS = [
  '.js',
  '.json',
  '.jsx',
  '.css',
  '.scss',
];

export default ({
  entry,
  outputDir,
  publicDir = outputDir,
  mode = process.env.NODE_ENV,
  scssDir,
}) => {
  const defaultConfig = generateConfig({ entry, outputDir, mode });

  return merge(defaultConfig, {
    optimization: {
      splitChunks: {
        cacheGroups: {
          commons: {
            test: /node_modules/,
            name: 'vendor',
            chunks: 'all',
          },
        },
      },
    },

    resolve: {
      extensions: EXTENSIONS,
    },

    output: {
      publicPath: `${publicDir}/`,
    },

    module: {
      rules: [
        ...defaultConfig.module.rules,
        scssRule(),
        filesRule(outputDir),
      ],
    },

    plugins: [
      ...defaultConfig.plugins,
      manifestPlugin(),
      scssPlugin({
        includePaths: [
          cwd(scssDir || ''),
          cwd('node_modules'),
        ],
      }),
      processEnvPlugin(),
    ],
  });
};
